import {
  ActionType,
  Action,
  CreateQuestionnairesResponse,
} from "models/questionnaires/createQuestionnaires";
import createReducer from "../../createReducer";

export interface CreateQuestionnairesReducerType {
  loading: boolean;
  error?: string;
  createQuestionnairesResponse?: CreateQuestionnairesResponse;
}

const defaultState: CreateQuestionnairesReducerType = {
  loading: false,
  error: undefined,
  createQuestionnairesResponse: undefined,
};

export const createQuestionnairesReducer =
  createReducer<CreateQuestionnairesReducerType>(defaultState, {
    [ActionType.CREATE_QUESTIONNAIRES](state: CreateQuestionnairesReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.CREATE_QUESTIONNAIRES_ERROR](
      state: CreateQuestionnairesReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        createQuestionnairesResponse: undefined,
      };
    },

    [ActionType.CREATE_QUESTIONNAIRES_SUCCESS](
      state: CreateQuestionnairesReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        createQuestionnairesResponse: action.payload,
      };
    },

    [ActionType.CREATE_QUESTIONNAIRES_RESET](
      state: CreateQuestionnairesReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        createQuestionnairesResponse: undefined,
      };
    },
  });
